import React, { useEffect, useState } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import { format } from "date-fns";
import { PieChart, Pie, Cell, ResponsiveContainer } from "recharts";
import axios from "axios";

import * as APIDashboard from "../../../../services/nps/functions";

import Typography from "../../../../components/Typography";
import Dots from "../../../Loading/Dots/Dots";

import { ReactComponent as SentimentExcitedIcon } from "../../../../build/images/nps-dashboard-icons/sentiment_excited.svg";
import { ReactComponent as MoodBadIcon } from "../../../../build/images/nps-dashboard-icons/mood_bad.svg";
import { ReactComponent as SentimentExtremelyDissatisfiedIcon } from "../../../../build/images/nps-dashboard-icons/sentiment_extremely_dissatisfied.svg";
import { ReactComponent as InfoIcon } from "../../../../build/images/nps-dashboard-icons/info.svg";

import "./nps-date-three.css";
import Paperplane from "../../../Loading/Paperplane";

export default function NpsDateThree({ npsValue, loadingPieChartData }) {
  const filtersDashboard = useSelector((state) => state.npsfilters);
  const cardsOfQualityDash = useSelector((state) => state.cardsOfQualityDash);

  const defaultObj = {
    idade: "0-0",
    genero: "Nulo",
    convenio: "Nulo",
    horario: "00h",
    dia: "Nulo",
  };

  const [initialDate, setInitialDate] = useState(filtersDashboard.datestart);
  const [finalDate, setFinalDate] = useState(filtersDashboard.dateend);
  const [promoters, setPromoters] = useState([]);
  const [neutral, setNeutral] = useState([]);
  const [detractor, setDetractor] = useState([]);
  const [dispareFilter, setDispareFilter] = useState(false);
  const [loading, setLoading] = useState(false);

  const RADIAN = Math.PI / 180;
  const data = [
    { name: "A", value: 100, color: "#C90000" },
    { name: "B", value: 50, color: "#F4511E" },
    { name: "C", value: 25, color: "#F2BD00" },
    { name: "D", value: 25, color: "#008908" },
  ];
  const cx = 108;
  const cy = 110;
  const iR = 50;
  const oR = 100;
  const value = Number(npsValue) + 100;
  let totalLength = promoters.length + neutral.length + detractor.length;

  async function getProfileMapping(source) {
    //setLoading(true);
    const response = await APIDashboard.getProfileMapping(
      format(new Date(filtersDashboard.datestart), "yyyy-MM-dd"),
      format(new Date(filtersDashboard.dateend), "yyyy-MM-dd"),
      filtersDashboard.business.map((option) => option.id).join(),
      filtersDashboard.units.map((option) => option.id).join(),
      source,
      setLoading,
      filtersDashboard.questionsNPS.map((option) => option.id).join(),
      filtersDashboard.questionsCSAT.map((option) => option.id).join(),
      filtersDashboard.channels.map((option) => option.id).join(),
    );

    if (response && response.status === 200) {
      const data = response.data;
      if (data.length) {
        const infos = data[0];
        let promotor = JSON.parse(infos.promotor);
        let neutro = JSON.parse(infos.neutro);
        let detrator = JSON.parse(infos.detrator);

        promotor = promotor.length ? handleAgeData(promotor) : [];
        neutro = neutro.length ? handleAgeData(neutro) : [];
        detrator = detrator.length ? handleAgeData(detrator) : [];

        setPromoters(promotor);
        setNeutral(neutro);
        setDetractor(detrator);
      } else {
        setPromoters([]);
        setNeutral([]);
        setDetractor([]);
      }
      setDispareFilter(true);
    } else {
      console.log(
        "Falha, não foi possível carregar as informações!",
        "Verifique sua conexão e tente novamente mais tarde.",
      );
      //   Toast(
      //     "Falha, não foi possível carregar as informações!",
      //     "Verifique sua conexão e tente novamente mais tarde",
      //     "error"
      //   );
    }

    //setLoading(false);
  }

  const handleAgeData = (data) => {
    const dataFormatted = data.map((datum) => {
      if (datum.idade <= "09") {
        datum.idade = "1 - 9";
      } else if (datum.idade >= "10" && datum.idade <= "19") {
        datum.idade = "10 - 19";
      } else if (datum.idade >= "20" && datum.idade <= "29") {
        datum.idade = "20 - 29";
      } else if (datum.idade >= "30" && datum.idade <= "39") {
        datum.idade = "30 - 39";
      } else if (datum.idade >= "40" && datum.idade <= "49") {
        datum.idade = "40 - 49";
      } else if (datum.idade >= "50" && datum.idade <= "59") {
        datum.idade = "50 - 59";
      } else if (datum.idade >= "60" && datum.idade <= "69") {
        datum.idade = "60 - 69";
      } else if (datum.idade >= "70" && datum.idade <= "79") {
        datum.idade = "70 - 79";
      } else {
        datum.idade = "> 80";
      }

      if (datum.dia === 0) {
        datum.dia = "Domingo";
      } else if (datum.dia === 1) {
        datum.dia = "Segunda-feira";
      } else if (datum.dia === 2) {
        datum.dia = "Terça-feira";
      } else if (datum.dia === 3) {
        datum.dia = "Quarta-feira";
      } else if (datum.dia === 4) {
        datum.dia = "Quinta-feira";
      } else if (datum.dia === 5) {
        datum.dia = "Sexta-feira";
      } else if (datum.dia === 6) {
        datum.dia = "Sábado";
      }

      datum.horario = `${datum.horario}h`;
      datum.genero = datum.genero === "F" ? "Feminino" : "Masculino";

      return datum;
    });

    return dataFormatted;
  };

  function renderInfos(typeClient, idType) {
    return (
      <div className="container-classifications">
        <h5 className="container-classifications__h5">
          {idType === 1
            ? "Promotores"
            : idType === 2
              ? "Neutros"
              : "Detratores"}
        </h5>

        <span className="container-classifications__span">
          <p className="container-classifications__span__p">
            Faixa etária:{" "}
            <h5 className="container-classifications__span__h5">
              {typeClient.idade}
            </h5>
          </p>
          <p className="container-classifications__span__p">
            Sexo:
            <h5 className="container-classifications__span__h5">
              {typeClient.genero}
            </h5>
          </p>
          <p className="container-classifications__span__p">
            Convênio:
            <h5 className="container-classifications__span__h5">
              {typeClient.convenio}
            </h5>
          </p>
          <p className="container-classifications__span__p">
            Horário:
            <h5 className="container-classifications__span__h5">
              {typeClient.horario}
            </h5>
          </p>
          <p className="container-classifications__span__p">
            Dia:
            <h5 className="container-classifications__span__h5">
              {typeClient.dia}
            </h5>
          </p>
        </span>
      </div>
    );
  }

  const needle = (value, data, cx, cy, iR, oR, color) => {
    let total = 0;
    data.forEach((v) => {
      total += v.value;
    });
    const ang = 180.0 * (1 - value / total);
    const length = (iR + 2 * oR) / 3;
    const sin = Math.sin(-RADIAN * ang);
    const cos = Math.cos(-RADIAN * ang);
    const r = 8;
    const x0 = cx + 5;
    const y0 = cy + 5;
    const xba = x0 + r * sin;
    const yba = y0 - r * cos;
    const xbb = x0 - r * sin;
    const ybb = y0 + r * cos;
    const xp = x0 + length * cos;
    const yp = y0 + length * sin;

    return [
      <circle
        cx={x0}
        cy={y0}
        r={r + 10}
        fill="#2B2B2B"
        stroke="white"
        stroke-width="4"
      />,

      <path
        d={`M${xba} ${yba}L${xbb} ${ybb} L${xp} ${yp} L${xba} ${yba}`}
        stroke="#none"
        fill={"#2B2B2B"}
      />,
    ];
  };

  useEffect(() => {
    if (!cardsOfQualityDash.card8) return;

    const source = axios.CancelToken.source();

    if (!dispareFilter || filtersDashboard.active) {
      getProfileMapping(source);
      if (!dispareFilter) setDispareFilter(true);
    }

    return () => {
      source.cancel("Operation canceled by the user.");
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filtersDashboard, cardsOfQualityDash.card8]);

  /*
  useEffect(() => {
    getProfileMapping();
  }, []);

  useEffect(() => {
    if (filtersDashboard.active && dispareFilter) {
      getProfileMapping();
    }
  }, [filtersDashboard]);
*/
  return (
    (cardsOfQualityDash.card7 || cardsOfQualityDash.card8) && (
      <section className="nps-date-three-quality">
        {cardsOfQualityDash.card7 && (
          <div className="nps-zone-quality">
            <header className="nps-zone-content__header">
              <div className="cards-headers">
                <h4>NPS</h4>
              </div>
            </header>

            {loadingPieChartData ? (
              <Paperplane className="nps-zone-content__loading" />
            ) : (
              <div className="nps-zone-content__graphic">
                {/* GRÁFICO */}
                <div className="nps-zone-content__graphic__pizza">
                  <ResponsiveContainer width="99%" height="60%">
                    <PieChart>
                      <Pie
                        dataKey="value"
                        startAngle={180}
                        endAngle={0}
                        data={data}
                        cx={cx}
                        cy={cy}
                        // innerRadius={iR}
                        outerRadius={oR}
                        fill="#8884d8"
                        stroke="none"
                      >
                        {data.map((entry, index) => (
                          <Cell key={`cell-${index}`} fill={entry.color} />
                        ))}
                      </Pie>
                      {needle(value, data, cx, cy, iR, oR, "#d0d000")}
                    </PieChart>
                  </ResponsiveContainer>
                  <div className="nps-zone-content__graphic__value">
                    <Typography.H1 color={"white"} weight={700}>
                      {npsValue}
                    </Typography.H1>
                  </div>
                </div>

                <div className="nps-zone-content__graphic__zones">
                  <span className="tag-zone">
                    <div className="tag-zone__excellence" />

                    <h6 className="tag-zone__h6">
                      Zona de excelência (76 e 100)
                    </h6>
                  </span>
                  <span className="tag-zone">
                    <div className="tag-zone__quality" />

                    <h6 className="tag-zone__h6">
                      Zona de qualidade (51 e 75)
                    </h6>
                  </span>
                  <span className="tag-zone">
                    <div className="tag-zone__improvement" />

                    <h6 className="tag-zone__h6">
                      Zona de aperfeiçoamento (1 e 50)
                    </h6>
                  </span>
                  <span className="tag-zone">
                    <div className="tag-zone__criticism" />

                    <h6 className="tag-zone__h6">Zona crítica (-100 e 0)</h6>
                  </span>
                </div>
              </div>
            )}
          </div>
        )}

        {cardsOfQualityDash.card8 && (
          <div className="profile-mapping">
            <header className="profile-mapping__header">
              <div className="cards-headers">
                <h4>Mapeamento de perfil</h4>
              </div>
            </header>

            <div
              className={`profile-mapping__informations ${
                totalLength <= 1 || loading ? "center-profiles" : ""
              }`}
            >
              {loading ? (
                <Paperplane />
              ) : totalLength === 0 ? (
                <div className="profile-mapping-empty">
                  <InfoIcon />
                  <Typography.H5 color={"gray-180"} weight={700}>
                    Nenhum perfil foi encontrado!
                  </Typography.H5>
                </div>
              ) : (
                <>
                  {promoters.length ? (
                    <div className="profile-mapping-promoters">
                      <div className="profile-mapping-promoters__icon">
                        <SentimentExcitedIcon />
                      </div>

                      {renderInfos(promoters[0], 1)}
                    </div>
                  ) : (
                    ""
                  )}

                  {/* {neutral.length && promoters.length ? (
                    <span className="profile-mapping__informations__line" />
                  ) : (
                    ""
                  )} */}

                  {neutral.length ? (
                    <div className="profile-mapping-neutrals">
                      <div className="profile-mapping-neutrals__icon">
                        <MoodBadIcon />
                      </div>

                      {renderInfos(neutral[0], 2)}
                    </div>
                  ) : (
                    ""
                  )}

                  {/* {detractor.length && (neutral.length || promoters.length) ? (
                    <span className="profile-mapping__informations__line" />
                  ) : (
                    ""
                  )} */}

                  {detractor.length ? (
                    <div className="profile-mapping-detractors">
                      <div className="profile-mapping-detractors__icon">
                        <SentimentExtremelyDissatisfiedIcon />
                      </div>

                      {renderInfos(detractor[0], 3)}
                    </div>
                  ) : (
                    ""
                  )}
                </>
              )}
            </div>
          </div>
        )}
      </section>
    )
  );
}
